import apiHelper from '@/services/helper'

const addUserFirebase = async (param) => {
    try {
        let url = '/admin/user/create'
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const getListUser = async () => {
    try {
        let url = '/admin/user/get-all'
        // TODO response.data
        return (await apiHelper.getWithFirebaseToken(url)).data
    } catch (error) {
        throw new Error(error)
    }
}
const getListRegistedLandingPage = async (param) => {
    try {
        let url = '/admin/shop/registed/get-all'
        // TODO response.data
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const searchUserList = async (param) => {
    try {
        let url = '/admin/user/search'
        // TODO response.data
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const updateUserInfo = async (param) => {
    try {
        let url = '/admin/user/update'
        // TODO response.data
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const getUserByArrID = async (param) => {
    try {
        let url = '/admin/user/get-by-ids'
        // TODO response.data
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}
const updateLeadPool = async (param) => {
    try {
        let url = '/admin/shop/registed/update'
        // TODO response.data
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}
const updateExcelWeightRate = async (param) => {
    try {
        let url = '/admin/shop/update-excel'
        // TODO response.data
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}
const updateStatusRegisLandingPage = async (id, status) => {
    try {
        // let url = 'admin/shop/get-by-id?shop_id=' + id
        let url = '/admin/shop/registed/mark-checked?id=' + id + '&is_check=' + status
        // TODO response.data
        return (await apiHelper.getWithFirebaseToken(url)).data
    } catch (error) {
        throw new Error(error)
    }
}
const getUserListOpt = async (param) => {
    try {
        let url = '/admin/user/search-opt'
        // TODO response.data
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const getUserListOptSnakeaCase = async (param) => {
    try {
        let url = '/admin/user/search-opt'
        // TODO response.data
        return (await apiHelper.postWithFirebaseTokenSnakeaCase(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const upDateApproveStatus = async (param) => {
    try {
        let url = '/admin/user/update-approve-status'
        // TODO response.data
        return (await apiHelper.postWithFirebaseTokenSnakeaCase(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const getInvalidShopData = async (param) => {
    try {
        let url = '/admin/user/get-invalid-shop-data'
        // TODO response.data
        return (await apiHelper.postWithFirebaseTokenSnakeaCase(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const createPickupAddressShop = async (param) => {
    try {
        let url = '/admin/user/create-pickup-address-with-shop'
        // TODO response.data
        return (await apiHelper.postWithFirebaseTokenSnakeaCase(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const getAllPickupAddressShop = async (param) => {
    try {
        let url = '/admin/user/get-all-pickup-address-with-shop'
        // TODO response.data
        return (await apiHelper.postWithFirebaseTokenSnakeaCase(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const updatePickupAddressShop = async (param) => {
    try {
        let url = '/admin/user/update-pickup-address-with-shop'
        // TODO response.data
        return (await apiHelper.postWithFirebaseTokenSnakeaCase(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const searchUserAndShop = async (param) => {
    try {
        let url = '/admin/user/booking-search'
        // TODO response.data
        return (await apiHelper.postWithFirebaseTokenSnakeaCase(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const getPickupAddressWithShop = async (param) => {
    try {
        let url = '/admin/user/get-pickup-address-with-shop'
        // TODO response.data
        return (await apiHelper.postWithFirebaseTokenSnakeaCase(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const searchPickupAddressWithShop = async (param) => {
    try {
        let url = '/admin/user/search-pickup-address-with-shop'
        // TODO response.data
        return (await apiHelper.postWithFirebaseTokenSnakeaCase(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const deletePickupAddress = async (param) => {
    try {
        let url = '/admin/user/delete-pickup-address'
        // TODO response.data
        return (await apiHelper.postWithFirebaseTokenSnakeaCase(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const searchApprovedUser = async (param) => {
    try {
        let url = '/admin/user/search-approved'
        // TODO response.data
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const searchConfirmedUser = async (param) => {
    try {
        let url = '/admin/user/search-confirmed'
        // TODO response.data
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const searchActivatedUser = async (param) => {
    try {
        let url = '/admin/user/search-activated'
        // TODO response.data
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const searchWaitingUser = async (param) => {
    try {
        let url = '/admin/user/search-waiting'
        // TODO response.data
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const searchWaitingUserSnakeaCase = async (param) => {
    try {
        let url = '/admin/user/search-waiting'
        // TODO response.data
        return (await apiHelper.postWithFirebaseTokenSnakeaCase(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const searchAllCustomer = async (param) => {
    try {
        let url = '/admin/user/search-all'
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

export default {
    addUserFirebase,
    getListUser,
    searchUserList,
    updateUserInfo,
    getUserByArrID,
    getListRegistedLandingPage,
    updateStatusRegisLandingPage,
    updateLeadPool,
    updateExcelWeightRate,
    getUserListOpt,
    getUserListOptSnakeaCase,
    upDateApproveStatus,
    getInvalidShopData,
    createPickupAddressShop,
    getAllPickupAddressShop,
    updatePickupAddressShop,
    searchUserAndShop,
    getPickupAddressWithShop,
    searchPickupAddressWithShop,
    deletePickupAddress,
    searchApprovedUser,
    searchConfirmedUser,
    searchActivatedUser,
    searchWaitingUser,
    searchWaitingUserSnakeaCase,
    searchAllCustomer
}
